'use client'

import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import dynamic from 'next/dynamic'
import { useState } from 'react'

import { arbDialogOpenAtom, arbDialogSeedAtom } from '@/state/widget-actions'

// Lazy: the builder (with lightweight-charts) is ~1 MB of JS nobody needs until the dialog opens,
// and this host is mounted on every trade page.
const ArbBuilderDialog = dynamic(
  () => import('@/features/arb/components/arb-builder-dialog').then((m) => m.ArbBuilderDialog),
  { ssr: false }
)

// Single always-mounted instance for the whole trade layout — every arb entry point just flips
// arbDialogOpenAtom rather than each owning its own dialog. See use-open-arb-dialog.ts.
export function ArbBuilderDialogHost() {
  const [open, setOpen] = useAtom(arbDialogOpenAtom)
  const seed = useAtomValue(arbDialogSeedAtom)
  const setSeed = useSetAtom(arbDialogSeedAtom)
  // Mount on first open, then stay mounted so closing still animates out.
  const [hasOpened, setHasOpened] = useState(open)
  if (open && !hasOpened) setHasOpened(true)
  if (!hasOpened) return null
  return (
    <ArbBuilderDialog
      open={open}
      seed={seed}
      onOpenChange={(nextOpen) => {
        setOpen(nextOpen)
        if (!nextOpen) setSeed(null)
      }}
    />
  )
}
